class StockTemplateCell extends UITableViewCell
{
    private titleLabel:MUILabel = null;

    awakeFromHTML(){
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
    }

    set item (item:StockTemplate){
        this.titleLabel.text = item.name;
    }
}
